import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

function showServiceChoiceStep(claimVm) {
    var lossCauseCode = claimVm.lossCause.value.code;

    return (ApplicationFeatures.hasFeature('role.policyholder') || ApplicationFeatures.hasFeature('role.producer')) && ApplicationFeatures.hasFeature('repairOption') && lossCauseCode !== 'theftentire';
}

function getRepairOptionValue(claimVm) {
    if (!claimVm.lobs.personalAuto) {
        return;
    }
    return claimVm.lobs.personalAuto.repairOption.value;
}

function getRepairOptionChoice(claimVm) {
    var repairOption = getRepairOptionValue(claimVm);
    return repairOption ? repairOption.repairOptionChoice : undefined;
}

export default (function (LoadSaveService, $q, TranslateService) {
    var translateFn = TranslateService.instant;

    var ACTION_MSG = {
        createClaim: {
            error: {
                title: 'fnol.pa.config.FlowConfig.Error creating claim',
                message: 'fnol.pa.config.FlowConfig.An error occurred attempting to create personal auto claim.'
            },
            progress: {
                message: 'fnol.pa.config.FlowConfig.Creating personal auto draft claim...'
            }
        }
    };

    var ACTIONS = {
        createClaim: function createClaim(model) {
            if (model.claimNumber.value) {
                return $q.resolve(model);
            }
            return LoadSaveService.createClaim(model.value);
        }
    };

    return function (step, junction) {
        junction('paError');
        junction('paSuccess');

        step('paClaimType', true).onNext.doAction(ACTIONS.createClaim, ACTION_MSG.createClaim, { forceUpdate: true }).thenBranch(function (_ref) {
            var claim = _ref.value;

            var nextStep = 'paCollisionLossDetails';
            switch (claim.getLossCategory()) {
                case 'glass':
                    nextStep = 'paGlassDetails';
                    break;
                case 'theft':
                    nextStep = 'paTheftDetails';
                    break;
                case 'collision':
                    nextStep = 'paCollisionLossDetails';
                    break;
                default:
                    nextStep = 'paError';
                    break;
            }
            return nextStep;
        }, function () {
            return 'paError';
        }).skipOnResumeIf(function (_ref2) {
            var claim = _ref2.value;
            return claim.policy;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.steps.pa.Type of Incident');
        });

        step('paTheftDetails').onNext.branch(function (claimVm) {
            return showServiceChoiceStep(claimVm) ? 'paServiceChoice' : 'paSuccess';
        }).skipOnResumeIf(function (_ref3) {
            var claim = _ref3.value;
            return claim.lossCause === 'theftentire' && claim.lossLocation && claim.lossLocation.city;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.steps.pa.TheftDetails');
        });

        step('paGlassDetails').onNext.branch(function (claimVm) {
            return showServiceChoiceStep(claimVm) ? 'paServiceChoice' : 'paSuccess';
        }).skipOnResumeIf(function (_ref4) {
            var claim = _ref4.value;
            return claim.lossCause === 'glassbreakage' && claim.lossLocation && claim.lossLocation.city;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.steps.pa.GlassDetails');
        });

        step('paCollisionLossDetails').onNext.goTo('paCollisionVehicles').skipOnResumeIf(function (_ref5) {
            var claim = _ref5.value;
            return claim.lossCause && claim.lossLocation && claim.lossLocation.city;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.steps.pa.CollisionDetails');
        });

        step('paCollisionVehicles').onNext.branch(function (claimVm) {
            return showServiceChoiceStep(claimVm) ? 'paServiceChoice' : 'paSuccess';
        }).skipOnResumeIf(function (_ref6) {
            var claim = _ref6.value;
            return claim.lobs.personalAuto.vehicleIncidents[0];
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.steps.pa.Vehicles');
        });

        step('paServiceChoice').onNext.branch(function (claimVm) {
            switch (getRepairOptionChoice(claimVm)) {
                case 'NewVendor':
                    return 'paNewRepairFacility';
                case 'PreferredVendor':
                    return 'paPreferredRepairFacility';
                case 'NoRepair':
                    return 'paSuccess';
                default:
                    return 'paSuccess'; // Not a valid case Allows the wizard to display subsequent steps
            }
        }).skipOnResumeIf(function (claimVm) {
            return getRepairOptionChoice(claimVm);
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.steps.pa.Repair');
        });

        step('paNewRepairFacility').onNext.goTo('paSuccess').skipOnResumeIf(function (claimVm) {
            return getRepairOptionValue(claimVm).repairFacility;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.steps.pa.Repair Facility');
        });

        step('paPreferredRepairFacility').onNext.goTo('paSuccess').skipOnResumeIf(function (claimVm) {
            return getRepairOptionValue(claimVm).repairFacility;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.steps.pa.Repair Facility');
        });
    };
});